import FundSelectForMeetingRequest from './FundSelectForMeetingRequest'

export default FundSelectForMeetingRequest
